export enum ContentCreationSlugs {
    PRESSRELEASE = "press-release",
    HEALTHBLOG = "health-blog",
    SOCIALPOST = "social-post",
    MARKETINGEMAILER = "marketing-emailer",
    FEATUREARTICLE = "feature-article",
    SCIENTIFICARTICLE="scientific-article",
    
    //disable
    HEALTHFAQS = "health-faqs",
    PATIENTEDUCATION = "patient-education",
    SCIENTIFICLBL = "scientific-lbl",
    VISUALAID = "visual-aid"
}
 
export namespace BlogTypesActions {
    export enum BlogTypes {
        LISTICLE = "Listicle",
        HEALTHINFORMATIONBLOG = "Health Information Blog",
        OPINIONBLOG = "Opinion Blog",
        CASESTUDY = "Case Study"
    }
}



export namespace SmpActions {
    export enum SmpPurpose {
        EDUCATIONAL = "educational",
        QA = "qa",
        NEWS = "news",
        ANNOUNCEMENT = "announcement",
        POV = "pov"
    }
 
    export enum SmpPurposeLabel {
        EDUCATIONAL = "Educational",
        QA = "Question and Answer",
        NEWS = "News",
        ANNOUNCEMENT = "Announcement",
        POV = "Point of View"
    }
 
    export const SmpPurposeToLabelMap: Record<SmpPurpose, SmpPurposeLabel> = {
        [SmpPurpose.EDUCATIONAL]: SmpPurposeLabel.EDUCATIONAL,
        [SmpPurpose.QA]: SmpPurposeLabel.QA,
        [SmpPurpose.NEWS]: SmpPurposeLabel.NEWS,
        [SmpPurpose.ANNOUNCEMENT]: SmpPurposeLabel.ANNOUNCEMENT,
        [SmpPurpose.POV]: SmpPurposeLabel.POV
    };

    
 
    export const SmpLabelToPurposeMap: Record<SmpPurposeLabel, SmpPurpose> = {
        [SmpPurposeLabel.EDUCATIONAL]: SmpPurpose.EDUCATIONAL,
        [SmpPurposeLabel.QA]: SmpPurpose.QA,
        [SmpPurposeLabel.NEWS]: SmpPurpose.NEWS,
        [SmpPurposeLabel.ANNOUNCEMENT]: SmpPurpose.ANNOUNCEMENT,
        [SmpPurposeLabel.POV]: SmpPurpose.POV
    };
 
    export enum SmpTypes {
        FACEBOOK = "facebook",
        INSTAGRAM = "instagram",
        LINKEDIN = "linkedin"
    }
 
    export enum SmpTypeLabels {
        FACEBOOK = "Facebook",
        INSTAGRAM = "Instagram",
        LINKEDIN = "LinkedIn"
    }
 
    export const SmpTypeToLabelMap: Record<SmpTypes, SmpTypeLabels> = {
        [SmpTypes.FACEBOOK]: SmpTypeLabels.FACEBOOK,
        [SmpTypes.INSTAGRAM]: SmpTypeLabels.INSTAGRAM,
        [SmpTypes.LINKEDIN]: SmpTypeLabels.LINKEDIN
    };
 
    export const SmpLabelToTypeMap: Record<SmpTypeLabels, SmpTypes> = {
        [SmpTypeLabels.FACEBOOK]: SmpTypes.FACEBOOK,
        [SmpTypeLabels.INSTAGRAM]: SmpTypes.INSTAGRAM,
        [SmpTypeLabels.LINKEDIN]: SmpTypes.LINKEDIN
    };
}
 
 
export namespace EmailActions {
    export enum EmailPurpose {
        CAMPAIGN = "campaign",
        AR = "ar",
        HCP = "hcp",
        PE = "pe"
    }
    export enum EmailPurposeLabel {
        CAMPAIGN = "Campaign",
        AR = "Announcement and Research Email",
        HCP = "Healthcare Professional",
        PE = "Patient Education"
    }
    export const EmailPurposeToLabelMap: Record<EmailPurpose, EmailPurposeLabel> = {
        [EmailPurpose.CAMPAIGN]: EmailPurposeLabel.CAMPAIGN,
        [EmailPurpose.AR]: EmailPurposeLabel.AR,
        [EmailPurpose.HCP]: EmailPurposeLabel.HCP,
        [EmailPurpose.PE]: EmailPurposeLabel.PE
    };
    export const EmailLabelToPurposeMap: Record<EmailPurposeLabel, EmailPurpose> = {
        [EmailPurposeLabel.CAMPAIGN]: EmailPurpose.CAMPAIGN,
        [EmailPurposeLabel.AR]: EmailPurpose.AR,
        [EmailPurposeLabel.HCP]: EmailPurpose.HCP,
        [EmailPurposeLabel.PE]: EmailPurpose.PE
    };

}

export namespace ScientificActions{
    export enum ScientificOpinionTypes {
        CLINICALPERSPECTIVE = "clinical perspective",
        RESEARCHCOMMENTARY = "research commentary",
        HEALTHCAREPOLICYANALYSIS = "healthcare policy analysis",
        POVPIECE = "pov piece",
        EXPERTOPINION = "expert opinion"
    }
    export enum ScientificOpinionTypeLabels {
        CLINICALPERSPECTIVE = "Clinical Perspective",
        RESEARCHCOMMENTARY = "Research Commentary",
        HEALTHCAREPOLICYANALYSIS = "Healthcare Policy Analysis",
        POVPIECE = "POV Piece",
        EXPERTOPINION = "Expert Opinion"
    }
    export const ScientificOpinionTypeToLabelMap: Record<ScientificOpinionTypes, ScientificOpinionTypeLabels> = {
        [ScientificOpinionTypes.CLINICALPERSPECTIVE]: ScientificOpinionTypeLabels.CLINICALPERSPECTIVE,
        [ScientificOpinionTypes.RESEARCHCOMMENTARY]: ScientificOpinionTypeLabels.RESEARCHCOMMENTARY,
        [ScientificOpinionTypes.HEALTHCAREPOLICYANALYSIS]: ScientificOpinionTypeLabels.HEALTHCAREPOLICYANALYSIS,
        [ScientificOpinionTypes.POVPIECE]: ScientificOpinionTypeLabels.POVPIECE,
        [ScientificOpinionTypes.EXPERTOPINION]: ScientificOpinionTypeLabels.EXPERTOPINION
    }
    export const ScientificOpinionLabelToTypeMap: Record<ScientificOpinionTypeLabels, ScientificOpinionTypes> = {
        [ScientificOpinionTypeLabels.CLINICALPERSPECTIVE]: ScientificOpinionTypes.CLINICALPERSPECTIVE,
        [ScientificOpinionTypeLabels.RESEARCHCOMMENTARY]: ScientificOpinionTypes.RESEARCHCOMMENTARY,
        [ScientificOpinionTypeLabels.HEALTHCAREPOLICYANALYSIS]: ScientificOpinionTypes.HEALTHCAREPOLICYANALYSIS,
        [ScientificOpinionTypeLabels.POVPIECE]: ScientificOpinionTypes.POVPIECE,
        [ScientificOpinionTypeLabels.EXPERTOPINION]: ScientificOpinionTypes.EXPERTOPINION
    }
}



export namespace VisualAidActions {
	export enum VisualAidTypes {
		ORIGINATORLAUNCH = "originator launch",
		GLOBALGENERICENTRY = "global generic entry",
		LATEENTRANT = "late entrant",
		INDICATIONEXPANSION = "indication expansion",
		NEWSKU = "new sku",
		REMINDERVISUALAID = "reminder visual aid"
	}

	export enum VisualAidTypeLabels {
		ORIGINATORLAUNCH = "Originator Launch",
		GLOBALGENERICENTRY = "Global Generic Entry",
		LATEENTRANT = "Late Entrant",
		INDICATIONEXPANSION = "Indication Expansion",
		NEWSKU = "New SKU",
		REMINDERVISUALAID = "Reminder Visual Aid"
	}

	export const VisualAidTypeToLabelMap: Record<
		VisualAidTypes,
		VisualAidTypeLabels
	> = {
		[VisualAidTypes.ORIGINATORLAUNCH]:
			VisualAidTypeLabels.ORIGINATORLAUNCH,
		[VisualAidTypes.GLOBALGENERICENTRY]:
			VisualAidTypeLabels.GLOBALGENERICENTRY,
		[VisualAidTypes.LATEENTRANT]: VisualAidTypeLabels.LATEENTRANT,
		[VisualAidTypes.INDICATIONEXPANSION]:
			VisualAidTypeLabels.INDICATIONEXPANSION,
		[VisualAidTypes.NEWSKU]: VisualAidTypeLabels.NEWSKU,
		[VisualAidTypes.REMINDERVISUALAID]:
			VisualAidTypeLabels.REMINDERVISUALAID
	}

	export const VisualAidLabelToTypeMap: Record<
		VisualAidTypeLabels,
		VisualAidTypes
	> = {
		[VisualAidTypeLabels.ORIGINATORLAUNCH]:
			VisualAidTypes.ORIGINATORLAUNCH,
		[VisualAidTypeLabels.GLOBALGENERICENTRY]:
			VisualAidTypes.GLOBALGENERICENTRY,
		[VisualAidTypeLabels.LATEENTRANT]: VisualAidTypes.LATEENTRANT,
		[VisualAidTypeLabels.INDICATIONEXPANSION]:
			VisualAidTypes.INDICATIONEXPANSION,
		[VisualAidTypeLabels.NEWSKU]: VisualAidTypes.NEWSKU,
		[VisualAidTypeLabels.REMINDERVISUALAID]:
			VisualAidTypes.REMINDERVISUALAID
	}
}